import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    const savedScroll = sessionStorage.getItem(
      "products_scroll_y"
    );

    const isReturningToProducts =
      pathname === "/products" &&
      navigationType === "POP" &&
      savedScroll;

    // Back button + saved scroll exists
    // let Products.jsx restore it
    if (isReturningToProducts) return;

    // No saved position → go top
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, [pathname, navigationType]);

  return children || null;
};

export default ScrollToTop;